import commonExtend from '../common/extend';
export default [...commonExtend

// Imperative override() call for FileManagerModal (a third-party
// extension's component) lives in ./index.tsx instead of here, since it
// isn't expressible as a declarative Extend.* class.
];